<template>
  <div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner py-2">
      <b-card class="mb-0">
        <b-img
          center
          fluid
          :src="require('@/assets/images/logo/LOGOREUNIBOX.png')"
        />
        <br>
        <b-card-title class="mb-1">
          Nouveau mot de passe
        </b-card-title>
        <b-form @submit.prevent="submit">
          <b-form-group label="Mot de passe (8 caractères minimum)">
            <b-form-input
              v-model="password"
              type="password"
              required
              minlength="8"
            />
          </b-form-group>
          <b-form-group label="Confirmation">
            <b-form-input
              v-model="confirm"
              type="password"
              required
              minlength="8"
            />
          </b-form-group>
          <b-alert
            v-if="error"
            variant="danger"
            show
          >
            {{ error }}
          </b-alert>
          <b-button
            type="submit"
            variant="primary"
            block
            :disabled="loading"
          >
            <b-spinner
              v-if="loading"
              small
            />
            <span v-else>Définir le mot de passe</span>
          </b-button>
        </b-form>
        <p class="text-center mt-2">
          <b-link :to="{ name: 'admin-dom-login' }">
            Retour à la connexion
          </b-link>
        </p>
      </b-card>
    </div>
  </div>
</template>

<script>
/* eslint-disable global-require */
import {
  BCard, BCardTitle, BImg, BForm, BFormGroup, BFormInput, BButton, BSpinner, BAlert, BLink,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BCard, BCardTitle, BImg, BForm, BFormGroup, BFormInput, BButton, BSpinner, BAlert, BLink,
  },
  data() {
    return {
      password: '',
      confirm: '',
      loading: false,
      error: '',
    }
  },
  methods: {
    submit() {
      this.error = ''
      if (this.password !== this.confirm) {
        this.error = 'Les mots de passe ne correspondent pas'
        return
      }
      if (this.password.length < 8) {
        this.error = '8 caractères minimum'
        return
      }
      this.loading = true
      this.$http.post('/admindom/resetpassword', {
        token: this.$route.params.token,
        password: this.password,
      })
        .then(response => {
          this.loading = false
          if (response.data.res === 1) {
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: { title: 'Mot de passe modifié', variant: 'success', icon: 'CheckCircleIcon' },
            })
            this.$router.push({ name: 'admin-dom-login' })
          } else {
            this.error = response.data.message || 'Erreur'
          }
        })
        .catch(() => {
          this.loading = false
          this.error = 'Erreur serveur'
        })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
